import React from 'react';

const Gallery = () => {
  const galleryItems = [
    {
      id: 1,
      title: "Premium Wigs",
      category: "Wig Collection",
      image: "./p1.png",
      gallery: "./p1.png",
      description: "High-quality wigs in various styles and colors to suit every personality and occasion."
    },
    {
      id: 2,
      title: "Hair Coloring",
      category: "Color Services",
      image: "./p2.png",
      gallery: "./p2.png",
      description: "Professional hair coloring services using premium products for vibrant, long-lasting results."
    },
    {
      id: 3,
      title: "Hair Revamping",
      category: "Makeover Services",
      image: "./p3.png",
      gallery: "./p3.png",
      description: "Complete hair transformations that enhance your natural beauty and boost your confidence."
    },
    {
      id: 4,
      title: "Wig Styling",
      category: "Styling Services",
      image: "./p4.png",
      gallery: "./p4.png",
      description: "Expert wig styling and fitting services for the perfect look that suits your face shape."
    },
    {
      id: 5,
      title: "Hair Ventilation",
      category: "Specialized Services",
      image: "./p5.png",
      gallery: "./p5.png",
      description: "Advanced hair ventilation techniques for natural-looking hair restoration and enhancement."
    },
    {
      id: 6,
      title: "Beauty Treatments",
      category: "Beauty Services",
      image: "./p6.png",
      gallery: "./p6.png",
      description: "Comprehensive beauty treatments to complement your hair services and enhance your overall look."
    }
  ];

  return (
    <section id="works" className="py-16 md:py-24 bg-gradient-to-br from-purple-50 via-white to-pink-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-purple-800 via-purple-600 to-pink-600 bg-clip-text text-transparent mb-4">
            Our Services
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-pink-600 mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-20">
          {galleryItems.map((item) => (
            <div key={item.id} className="group cursor-pointer transform hover:scale-105 transition-all duration-300">
              <div className="relative overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 border border-purple-100">
                <div className="relative overflow-hidden">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="w-full h-64 md:h-72 lg:h-80 object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-purple-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="px-3 py-1 text-xs font-semibold text-purple-700 bg-purple-100 rounded-full">
                      {item.category}
                    </span>
                  </div>
                  <h4 className="text-xl md:text-2xl font-bold text-purple-800 mb-3 group-hover:text-purple-600 transition-colors">
                    {item.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-xl border border-purple-100">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-purple-800 to-pink-600 bg-clip-text text-transparent mb-4">
              What Our Clients Say
            </h3>
            <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-pink-600 mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            <div className="text-center group">
              <div className="relative mb-6">
                <img 
                  src="./p7.png" 
                  alt="Client" 
                  className="w-20 h-20 md:w-24 md:h-24 rounded-full mx-auto object-cover border-4 border-purple-200 group-hover:border-purple-400 transition-colors shadow-lg"
                />
                <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              </div>
              <div className="mb-4">
                <strong className="text-lg md:text-xl text-purple-800">Adaeze Okafor</strong>
                <div className="text-sm text-purple-600 font-medium">Business Executive</div>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl">
                <p className="text-gray-700 italic leading-relaxed">
                  "Khair Spa transformed my look completely! The wig styling service was exceptional, 
                  and the staff made me feel so comfortable. I've never felt more confident."
                </p>
              </div>
            </div>

            <div className="text-center group">
              <div className="relative mb-6">
                <img 
                  src="./p1.png" 
                  alt="Client" 
                  className="w-20 h-20 md:w-24 md:h-24 rounded-full mx-auto object-cover border-4 border-purple-200 group-hover:border-purple-400 transition-colors shadow-lg"
                />
                <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              </div>
              <div className="mb-4">
                <strong className="text-lg md:text-xl text-purple-800">Chioma Nwankwo</strong>
                <div className="text-sm text-purple-600 font-medium">Fashion Enthusiast</div>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl">
                <p className="text-gray-700 italic leading-relaxed">
                  "The hair coloring service at Khair Spa is amazing! They used high-quality products 
                  and the results exceeded my expectations. Highly recommend their services."
                </p>
              </div>
            </div>

            <div className="text-center group">
              <div className="relative mb-6">
                <img 
                  src="./p2.png" 
                  alt="Client" 
                  className="w-20 h-20 md:w-24 md:h-24 rounded-full mx-auto object-cover border-4 border-purple-200 group-hover:border-purple-400 transition-colors shadow-lg"
                />
                <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              </div>
              <div className="mb-4">
                <strong className="text-lg md:text-xl text-purple-800">Blessing Okoro</strong>
                <div className="text-sm text-purple-600 font-medium">Teacher</div>
              </div>
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-2xl">
                <p className="text-gray-700 italic leading-relaxed">
                  "Khair Spa's hair revamping service gave me a completely new look! The team is 
                  professional, skilled, and they really understand what works best for each client."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;